import { Show, Tab, TabbedShowLayout, TabbedShowLayoutTabs, useRecordContext} from "react-admin";
import CustomerMetaShow from "./CustomerMeta";
import { useLocation } from "react-router-dom";
import CustomerHouseTab from "./CustomerHouseTab";
import UserPayoutTab from "../Payout/UserPayoutTab";
import React, { useEffect, useState } from "react";
import {
  Grid,
  Stack,
} from "@mui/material";
import TransactionButton from "../Common/TransactionButton";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { CouponSkuService } from "../../services/CouponSkuService";
import ResourceSelectDialog from "../Common/ResourceSelectDialog";
import CouponSkuList from "../CouponSku/CouponSkuList";
import { useAppDispatch } from "../../store/hooks";
import { setCustomSelectOpen } from "../../store/reducers/customSelect";
import { AddBankAccountDialog } from "../Common/AddBankAccountDialog";
import { PayoutUserType } from "../../enums/PayoutEnums";
import UpdateTagDialog from "../Common/UpdateTagDialog";
import CustomerTransaction from "./CustomerTransaction";
import { WalletService } from "../../services/WalletService";
import CustomerWalletTransactions from "./CustomerWalletTransactions";
import VendorTipListForCustomer from "../VendorTip/VendorTipListForCustomer";
import CustomerPromotionalBalanceList from "./CustomerPromotionalBalanceList";
import CreateWalletNegativeEntryDialog from "../Common/CreateWalletNegativeEntryDialog";
import SettleNegativeWalletBalanceDialog from "../Common/SettleNegativeWalletBalanceDialog";
import CookAdditionalDetails from "../Cooks/CookAdditionalDetails";
import CustomerCallLogs from "./CustomerCallLogs";
import CustomerComboExtensionsTab from "./CustomerComboExtensionsTab";
import CustomerPreferences from "./CustomerPref";
import SendCommunicationDialog from "../CommunicationManagement/SendCommunicationDialog";
import CustomerCommunicationHistory from "../CommunicationManagement/CustomerCommunicationHistory";
import CustomerWalletRefundsTab from "./CustomerWalletRefundsTab";
import CustomerCookRatingsTab from "./CustomerCookRatingsTab";
import CustomerChefForPartyTab from "./CustomerChefForPartyTab";
import CustomerOmsTableTab from "./CustomerOmsTableTab";
import CustomerCartTab from "./CustomerCartTab";
import ChangeCustomerPhoneDialog from "../Common/ChangeCustomerPhoneDialog";
import CustomerCouponSkuTab from "./CustomerCouponSkuTab";
import ServiceNotificationsTab from "../Common/ServiceNotificationsTab";

let walletService = new WalletService();
const couponSkuService = new CouponSkuService();

const RenderCTAButtons = (props: any) => {
  return (
    <Stack p={2}>
      <Grid container spacing={2} justifyContent="flex-end">
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenAddBankAccountDialog(true);
            }}
            name={"Add UPI/Bank Account"}
          />
        </Grid>
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenTagDialog(true);
            }}
            name={"Update Tag"}
          />
        </Grid>
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenWalletEntryDialog(true);
            }}
            name={"Create Wallet Negative Entry"}
            color={'error'}
          />
        </Grid>
        {Number(props.userWallet?.amount ?? 0) < 0 && (
          <Grid item>
            <TransactionButton
              onClickHandler={() => {
                props.setOpenSettleWalletDialog(true);
              }}
              name={"Settle Negative Balance"}
              color={'success'}
            />
          </Grid>
        )}
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenCommunicationDialog(true);
            }}
            name={"Send Communication"}
            color={'info'}
          />
        </Grid>
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenChangePhoneDialog(true);
            }}
            name={"Change Phone Number"}
            color={'warning'}
          />
        </Grid>
        <Grid item>
          <TransactionButton
            onClickHandler={() => {
              props.setOpenAddCouponSkuDialog(true);
            }}
            name={"Add Coupon SKU"}
            color={'success'}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

const CustomerTabShow = (props: any) => {
  let location = useLocation();
  let customerId = location.pathname.split("/")[2];

  let { userWallet } = props;
  let record = useRecordContext();

  return (
    <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" scrollButtons="auto" selectionFollowsFocus={true} />}>
      <Tab label={"Details"}>
        <CustomerMetaShow userWallet = {userWallet}/>
      </Tab>
      <Tab label={"Chef For Party"}>
        <CustomerChefForPartyTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"CHEFIT"}>
        <CustomerOmsTableTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Carts"}>
        <CustomerCartTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Customer Preference"}>
        <CustomerPreferences />
      </Tab>
      <Tab label={"House Details"}>
        <CustomerHouseTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Bank Details"}>
        <UserPayoutTab
          userType={PayoutUserType.CUSTOMER}
          userId={parseInt(customerId)}
        />
      </Tab>
      <Tab label={"Transaction Details"}>
        <CustomerTransaction customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"User Wallet Transactions"}>
        <CustomerWalletTransactions walletId={parseInt(userWallet?.id)} />
      </Tab>
      <Tab label={"Customer Tips"}>
        <VendorTipListForCustomer customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Promotional Balances"}>
        <CustomerPromotionalBalanceList walletId={parseInt(userWallet?.id)} />
      </Tab>
      <Tab label={"Coupon SKUs"}>
        <CustomerCouponSkuTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Customer Extra Details"}>
        <CookAdditionalDetails partyId={parseInt(customerId)} referenceModel='CUSTOMER_MODEL'/>
      </Tab>
      <Tab label={"Call Logs"}>
        <CustomerCallLogs userPhone={record?.mobile} />
      </Tab>
      <Tab label={"Pack Extensions"}>
        <CustomerComboExtensionsTab userId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Communication History"}>
        <CustomerCommunicationHistory customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Wallet Refunds"}>
        <CustomerWalletRefundsTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Cook Ratings"}>
        <CustomerCookRatingsTab customerId={parseInt(customerId)} />
      </Tab>
      <Tab label={"Notifications"}>
        <ServiceNotificationsTab userId={parseInt(customerId)} userType="CUSTOMER" />
      </Tab>
    </TabbedShowLayout>
  );
};
const CustomerShow = (props: any) => {
  let location = useLocation();
  let customerId = location.pathname.split("/")[2];
  const dispatch = useAppDispatch();

  const [openAddBankAccountDialog, setOpenAddBankAccountDialog] =
    useState<boolean>(false);
  const [openTagDialog, setOpenTagDialog] = useState<boolean>(false);
  const [openWalletEntryDialog, setOpenWalletEntryDialog] = useState<boolean>(false);
  const [openCommunicationDialog, setOpenCommunicationDialog] = useState<boolean>(false);
  const [openChangePhoneDialog, setOpenChangePhoneDialog] = useState<boolean>(false);
  const [openAddCouponSkuDialog, setOpenAddCouponSkuDialog] = useState<boolean>(false);
  const [openSettleWalletDialog, setOpenSettleWalletDialog] = useState<boolean>(false);
  const [userWallet, setUserWallet] = useState<any>(null);

  const fetchUserWallet = React.useCallback(async () => {
    if (!customerId) return;
    try {
      const response = await walletService.getUserWallet(Number(customerId));
      setUserWallet(response);
    } catch (error) {
      // HttpClient error interceptor already surfaces the snackbar.
    }
  }, [customerId]);

  useEffect(() => {
    fetchUserWallet();
  }, [fetchUserWallet]);

  const handleSkuSelected = async (selectedSku: any) => {
    if (!selectedSku?.id) return;
    try {
      await couponSkuService.assignCustomersToSku(selectedSku.id, [Number(customerId)]);
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Coupon SKU added to customer successfully",
        type: CustomSnackbarTypes.SUCCESS,
      });
    } catch {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Failed to add coupon SKU",
        type: CustomSnackbarTypes.ERROR,
      });
    }
  };

  return (
    <div>
      <Show {...props} actions={false}>
        <RenderCTAButtons
          userWallet={userWallet}
          setOpenSettleWalletDialog={setOpenSettleWalletDialog}
          setOpenAddBankAccountDialog={setOpenAddBankAccountDialog}
          setOpenTagDialog={setOpenTagDialog}
          setOpenWalletEntryDialog={setOpenWalletEntryDialog}
          setOpenCommunicationDialog={setOpenCommunicationDialog}
          setOpenChangePhoneDialog={setOpenChangePhoneDialog}
          setOpenAddCouponSkuDialog={() => {
            dispatch(setCustomSelectOpen({ open: true }));
            setOpenAddCouponSkuDialog(true);
          }}
        />
        <CustomerTabShow userWallet={userWallet} />
        {openAddCouponSkuDialog && (
          <ResourceSelectDialog
            name={"CouponSku"}
            list={CouponSkuList}
            onClose={(record: any) => {
              setOpenAddCouponSkuDialog(false);
              handleSkuSelected(record);
            }}
          />
        )}
        <AddBankAccountDialog
          open={openAddBankAccountDialog}
          setOpen={setOpenAddBankAccountDialog}
          userType={PayoutUserType.CUSTOMER}
        />
        <UpdateTagDialog open={openTagDialog} setOpen={setOpenTagDialog} />
        <CreateWalletNegativeEntryDialog
          userId={customerId}
          open={openWalletEntryDialog}
          callback={()=>{
            setOpenWalletEntryDialog(false);
            window.location.reload();
        }}/>
        <SettleNegativeWalletBalanceDialog
          open={openSettleWalletDialog}
          setOpen={setOpenSettleWalletDialog}
          userId={parseInt(customerId)}
          userWallet={userWallet}
          onSettled={fetchUserWallet}
        />
        <SendCommunicationDialog
          open={openCommunicationDialog}
          onClose={() => setOpenCommunicationDialog(false)}
          customerId={parseInt(customerId)}
        />
        <ChangeCustomerPhoneDialog
          open={openChangePhoneDialog}
          setOpen={setOpenChangePhoneDialog}
        />
      </Show>
    </div>
  );
};
export default CustomerShow;
